import { lazy, Suspense, useEffect, useState } from 'react';
import { StepperContainer, StepperProvider } from './StepperContainer';
import { useAppSelector } from '../../../hooks/hooksRedux';
import { RootState } from '../../../store';
import { StepperContext } from '../../../components/Stepper/Context';

const OnboardingObjectivesPage = lazy(() => import('./ObjectivesPage'));
const OnboardingDirectorsPage = lazy(() => import('./DirectorsPage'));
const OnboardingShareholdersPage = lazy(() => import('./ShareholdersPage'));
const OnboardingMembersPage = lazy(() => import('./MembersPage'));
const OnboardingAddonsPage = lazy(() => import('./AddonsPage'));
const OnboardingSummaryPage = lazy(() => import('./SummaryPage'));

interface Step {
  id: string;
  order: number;
}

export const OnboardingOffshore = () => {
  const [steps, setSteps] = useState<Step[]>([{ id: 'objetives-step', order: 1 }]);
  const { jurisdictions } = useAppSelector((state: RootState) => state.onboarding);

  const currentJurisdiction = jurisdictions?.label;

  useEffect(() => {
    if (!currentJurisdiction) {
      return;
    }

    console.log('Current jurisdiction:', currentJurisdiction);

    setSteps((prevSteps) => {
      if (currentJurisdiction === 'Delaware') {
        // Verifica se os steps já estão definidos corretamente
        const delawareSteps = [
          { id: 'objetives-step', order: 1 },
          { id: 'members-step', order: 2 },
          { id: 'addons-step', order: 3 },
          { id: 'summary-step', order: 4 }
        ];

        // Se os steps já estão corretos, não atualiza
        if (JSON.stringify(prevSteps) === JSON.stringify(delawareSteps)) {
          return prevSteps;
        }

        return delawareSteps;
      } else {
        const otherSteps = [
          { id: 'objetives-step', order: 1 },
          { id: 'directors-step', order: 2 },
          { id: 'shareholders-step', order: 3 },
          { id: 'addons-step', order: 4 },
          { id: 'summary-step', order: 5 }
        ];

        // Se os steps já estão corretos, não atualiza
        if (JSON.stringify(prevSteps) === JSON.stringify(otherSteps)) {
          return prevSteps;
        }

        return otherSteps;
      }
    });
  }, [currentJurisdiction]); // Removido `jurisdictions` como dependência

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <StepperProvider steps={steps} initialStep="objetives-step">
        <StepperContainer step="objetives-step" component={OnboardingObjectivesPage} />

        {currentJurisdiction !== 'Delaware' && (
          <>
            <StepperContainer step="directors-step" component={OnboardingDirectorsPage} />
            <StepperContainer step="shareholders-step" component={OnboardingShareholdersPage} />
          </>
        )}

        {currentJurisdiction === 'Delaware' && (
          <StepperContainer step="members-step" component={OnboardingMembersPage} />
        )}

        <StepperContainer step="addons-step" component={OnboardingAddonsPage} />
        <StepperContainer step="summary-step" component={OnboardingSummaryPage} />
      </StepperProvider>
    </Suspense>
  );
};
